import { jsx as o, jsxs as m, Fragment as p } from "react/jsx-runtime";
import { twMerge as f } from "tailwind-merge";
import { useFloatHover as h } from "../../hooks/use-float-hover.mjs";
import { ActionMenuButtonWrapper as M } from "./action-menu-button-wrapper.mjs";
import { Menu as v, Transition as y, MenuItems as g } from "@headlessui/react";
const T = ({
  menuItems: i,
  anchor: s = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: c,
  toggleOnHover: r = !0,
  ...d
}) => {
  const { show: t, close: u, delayOpen: n, delayClose: a } = h();
  return /* @__PURE__ */ o(v, { children: ({ open: e, close: l }) => /* @__PURE__ */ m(p, { children: [
    /* @__PURE__ */ o(
      M,
      {
        ...d,
        active: r && t || e,
        onMouseEnter: n,
        onMouseLeave: a
      }
    ),
    /* @__PURE__ */ o(
      y,
      {
        show: r && t || e,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ o(
          g,
          {
            onClick: () => {
              l(), u();
            },
            static: !0,
            anchor: s,
            className: f(
              "bg-background-secondary border-background-tertiary overflow-hidden rounded-lg border shadow-lg focus:outline-hidden",
              c
            ),
            portal: !0,
            onMouseEnter: n,
            onMouseLeave: a,
            children: i
          }
        )
      }
    )
  ] }) });
};
export {
  T as ActionMenu
};
